module.exports = __webpack_public_path__ + "img/arrow-circle-broken-down.d7457da9.svg";